
import { Minus, Plus } from 'lucide-vue'
import recommendations from '~/components/common/recommendations.vue'
import * as shoppingCartLS from '@/lib/shoppingCartLS'
import * as productsLib from '@/lib/products'
import { getFormattedPrice } from '@/lib/utils'

export default {
  components: {
    recommendations,
    Minus,
    Plus,
  },

  data() {
    return {
      total: {
        quantity: 3,
        amount: 153000,
      },
      products: [],
      item: null,
      related: [],
      cartTitle: this.$t('shoppingCartModal.title.default'),
      isOpen: false,
    }
  },
  computed: {
    computedPercentage() {
      return Math.round((this.computedDisscount / this.computedSubTotal) * 100)
    },
    computedSubTotal() {
      return productsLib.calculateSubTotal(this.products)
    },
    computedTotal() {
      return productsLib.calculateTotal(this.products)
    },
    computedDisscount() {
      return productsLib.calculateDisscount(this.products)
    },
  },
  mounted() {
    this.recalculateItems()

    this.$bus.$on('reload', () => {
      this.recalculateItems()
    })

    this.$bus.$on('cart/remove-item', async (sku, done) => {
      try {
        this.$store.commit('isLoading', true)

        const cartId = shoppingCartLS.getCartId()
        if (!cartId) throw new Error('No cart id')

        await this.$store.dispatch('cart/updateCart', {
          cartId,
          product: {
            quantity: 0,
            sku,
          },
        })
        this.cartTitle = this.$t('shoppingCartModal.title.deleteProduct')
        shoppingCartLS.removeProduct(sku)
        this.$bus.$emit('reload')
        done?.(true)
      } catch (error) {
        this.$showModalDialog(
          this.$t('errorOccurred'),
          error.response?.data?.errors?.join('<br />'),
          'error'
        )
      } finally {
        this.$store.commit('isLoading', false)
      }
    })

    this.$bus.$on('cart/update', async (data) => {
      try {
        this.$store.commit('isLoading', true)
        if (!this.isOpen && this.$route.path !== '/cuenta/compras') {
          this.isOpen = true
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
        }

        const cartId = shoppingCartLS.getCartId()
        if (!cartId) throw new Error('No cart id')

        const { previusQuantity, ...productUpdate } = data

        const response = await this.$store.dispatch('cart/updateCart', {
          cartId,
          product: {
            quantity: productUpdate.qty,
            sku: productUpdate.sku,
          },
          realQuantity: previusQuantity,
        })

        this.related = response?.data?.related || []

        const productStorage = shoppingCartLS.getProducts()
        let found = false

        let previousQuantity = 0
        productStorage.forEach((product, index) => {
          if (product.sku === data.sku) {
            previousQuantity = productStorage[index].qty
            productStorage[index].qty = data.qty
            found = true
          }
        })
        if (!found) {
          productStorage.push(productUpdate)
        }

        const quantityDifference = data.qty - previousQuantity
        if (previousQuantity === 0) {
          this.cartTitle = this.$tc('shoppingCartModal.title.add', data.qty, {
            n: data.qty,
          })
        } else if (quantityDifference > 0) {
          this.cartTitle = this.$tc(
            'shoppingCartModal.title.add',
            quantityDifference,
            { n: quantityDifference }
          )
        } else if (quantityDifference < 0) {
          this.cartTitle = this.$tc(
            'shoppingCartModal.title.remove',
            -1 * quantityDifference,
            { n: -1 * quantityDifference }
          )
        }

        shoppingCartLS.setProducts(productStorage)
        document
          .querySelector('#sidebar-right .b-sidebar-body')
          .scrollTo({ top: 0, behavior: 'smooth' })
        this.$bus.$emit('reload')
      } catch (error) {
        console.error(error)
        this.$showModalDialog(
          this.$t('errorOccurred'),
          error.response?.data?.errors?.join('<br />') || 'error',
          'error'
        )
      } finally {
        this.$store.commit('isLoading', false)
      }
    })
  },
  methods: {
    getProductName(product) {
      let name = product.name
      if (typeof product.brand === 'string') name += `, "${product.brand}"`
      if (product.brand?.name) name += `, "${product.brand.name}"`
      if (product.year) name += `, ${product.year}`
      return name
    },
    goToCart() {
      if (this.$route.path.includes('cuenta/compras')) {
        this.isOpen = false
        this.$bus.$emit('change-step', 1) // o el número de step que quieras
      } else {
        this.$router.push(this.localePath('/cuenta/compras'))
      }

    },
    goToCartForward() {
      this.$router.push(this.localePath('/cuenta/compras?forward=true'))
    },
    recalculateItems() {
      this.products = shoppingCartLS.getProducts() || []

      let quantyProducts = 0
      let priceProducts = 0

      for (let i = 0; i < this.products.length; i++) {
        quantyProducts += this.products[i].qty
        priceProducts += this.products[i].price
      }

      this.total = {
        quantity: quantyProducts,
        amount: priceProducts,
      }
    },
    add(index) {
      this.products[index].qty++
      this.addCart(index)
    },
    remove(index) {
      this.products[index].qty--
      this.addCart(index)
    },
    removeItem(index) {
      this.$bus.$emit('cart/remove-item', this.products[index].sku)
    },
    addCart(index) {
      this.$bus.$emit('cart/update', {
        ...this.products[index],
        previusQuantity: this.products[index].qty,
      })
    },
    formatPrice(value) {
      return getFormattedPrice(value)
    },
    handleModalVisibleChange(visible) {
      if (visible) {
        this.cartTitle = this.$t('shoppingCartModal.title.default')
        this.related = []
      }
    },
  },
}
